export default __webpack_public_path__ + "static/login_background_img-c802db63a23fb9c4b3c866abeb0a18da.png";